module.exports = __webpack_public_path__ + "img/header.3c35601a.png";